import { projectsData } from '../projectsData';

/** Flatten the grouped project catalogue into what the assistant engine needs. */
export const projectIndex = Object.values(projectsData).flatMap((group) =>
  (group.projects || []).map((p) => ({
    id: p.id,
    title: p.title,
    category: group.title,
    subtitle: p.subtitle || '',
    description: p.description || '',
    technologies: p.technologies || p.tech || [],
    features: (p.features || []).slice(0, 3),
    liveUrl: p.liveUrl && !/demo\.com|your-/.test(p.liveUrl) ? p.liveUrl : null,
    githubUrl: p.githubUrl || null,
    featured: !!p.featured,
  }))
);
